import React from 'react'

const About = () => {
  return (
    <div>
      <div className="site-wrap" id="home-section"     style={{
            backgroundImage:
              "url(https://pricelessrentalsusa.com/wp-content/uploads/2023/07/mt-1582-home-header-bg-1.jpg)"
          }}>




        <div className="ftco-blocks-cover-1">
          <div className="ftco-cover-1 overlay innerpage">
            <div className="container">
              <div className="row align-items-center justify-content-center">
                <div className="col-lg-6 text-center">
                  <h1>About Us</h1>
                  <p>
                    We are a leading car rental company, offering a wide range of
                    vehicles for all your travel needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="site-section" style={{ backgroundColor: "#dfdaf3" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mb-2 mb-lg-0 order-lg-2">
              <img
                src="images/cars1.png"
                alt="Image"
                className="img-fluid"
                style={{ height: 400 }}
              />
            </div>
            <div className="col-lg-6">
              <h2>About Us</h2>
              <p>
                At Premium Car Rentals, we take pride in offering specialized
                corporate car rental services to meet your every travel need.
                Whether you prefer the freedom of self-drive, the luxury of
                chauffeur-driven rides, or require a delegation car rental, we have
                you covered.
              </p>
              <p>
                Our fleet includes a wide variety of premium vehicles, ranging from
                sleek sedans and robust SUVs to luxurious limousines and
                eco-friendly electric cars. Each vehicle in our lineup is
                meticulously maintained to ensure your safety and comfort at all
                times.
              </p>
              <p>
                With years of experience in the car rental industry, we are
                dedicated to providing personalized solutions tailored to your
                unique requirements. From corporate clients to individual travelers,
                we aim to deliver unparalleled quality and service every step of the
                way.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="site-section" style={{ backgroundColor: "#dfdaf3" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mb-2 mb-lg-0">
              <img
                src="images/car2.png"
                alt="Image"
                className="img-fluid"
                style={{ height: 400 }}
              />
            </div>
            <div className="col-lg-6">
              <p>
                Premium Car Rentals is more than just a car rental company; we are
                your trusted partner in making your travels memorable and enjoyable.
                Whether you’re embarking on a road trip, attending a special event,
                or simply need a temporary vehicle, we are here to exceed your
                expectations and provide you with a personalized, hassle-free
                experience.
              </p>
              <p>
                Our seamless booking process is designed to save you time and
                effort, allowing you to focus on the joy of your journey. With
                flexible pick-up and drop-off locations, 24/7 customer support, and
                transparent pricing, we strive to make car rental convenient and
                stress-free for every customer.
              </p>
              <p>
                Discover the convenience, reliability, and affordability that
                Premium Car Rentals has to offer. Get ready to embark on a journey
                filled with extraordinary service and unforgettable moments behind
                the wheel. Your satisfaction is our priority, and we are committed
                to making every drive a delightful experience.
              </p>
            </div>
          </div>
        </div>
      </div>
     
    </div>


  )
}

export default About
